import colors from 'colors'
import Border from 'components/Border'
import Button from 'components/Button'
import React, { FC } from 'react'
import styled from 'styled-components'
import { Exchange } from 'types'
import { getBadgeImage, getExchangeMeta } from 'utils'
import { O, pipe } from 'utils/fp'

const Container = styled.div`
  position: relative;
  padding: 16px;
  margin: 40px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
const Logo = styled.img`
  max-width: 60%;
`
const Desc = styled.p`
  margin: 12px 0;

  color: ${colors.black};
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
`
const List = styled.ul`
  padding: 0;
  margin: 0;
  align-self: flex-start;
  list-style-type: none;
`
const ListItem = styled.li`
  position: relative;
  margin: 8px 0;
  padding-left: 12px;

  display: flex;
  align-items: center;

  font-size: 12px;
  line-height: 14px;
  color: ${colors.black};

  &::before {
    content: '';
    position: absolute;

    top: 6px;
    left: 0;
    width: 4px;
    height: 4px;
    border-radius: 2px;
    background-color: ${colors.beige};
  }
`
const DetailLink = styled.a`
  position: relative;
  font-size: 12px;
  text-decoration: none;

  &::before {
    content: '';
    position: absolute;

    left: 0;
    right: 0;
    bottom: -5px;
    height: 4px;
    background-color: ${colors.beige};
  }
`
const GotoExchangeLink = styled(Button)`
  width: 262px;
  margin: 12px 0;
`
const BadgeImg = styled.img`
  position: absolute;
  width: 30px;
  height: 40px;
  top: -20px;
  left: 12px;
`

const shouldBreakLine = (k: string) => !['レバレッジ', '板取引'].includes(k)

const Cell: FC<{ exchange: Exchange; idx: number }> = ({ exchange, idx }) => {
  const code = exchange.code
  const meta = getExchangeMeta(code)
  const badgeImage = getBadgeImage(idx)
  return (
    <Container>
      <Border />
      <BadgeImg src={badgeImage} />
      <LogoWrapper>
        <Logo src={meta.logo} />
      </LogoWrapper>
      <Desc>{exchange.desc}</Desc>
      <List>
        {exchange.details.map(a => (
          <ListItem key={a[0]}>
            {a[0]}: {shouldBreakLine(a[0]) && <br />}
            {a[1]}
          </ListItem>
        ))}
      </List>
      <DetailLink href={meta.introURL} target="_blank">
        詳細を見る
      </DetailLink>
      <GotoExchangeLink
        onClick={() =>
          pipe(
            O.fromNullable(meta.url),
            O.map(a => window.open(a, '_blank')),
          )
        }
      >
        今すぐ口座開設
      </GotoExchangeLink>
    </Container>
  )
}

export default Cell
